import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Header from '../../components/molecules/Header/Header'
import ApplicationForm from '../../components/molecules/ApplicationForm/ApplicationForm'

import {
  ApplicationPageContainer,
  ApplicationPageInnerContainer,
  ApplicationPageLeftColumn,
  ApplicationPageLeftColumnInner,
  ApplicationPageRightColumn,
  LogoContainer,
  Logo,
  LogoTitle,
  LogoSubTitle,
  LogoDescription,
} from './ApplicationPage.css.js';

class ApplicationPage extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      header,
      page,
    } = this.props.content;

    return (
      <ApplicationPageContainer>
        <ApplicationPageInnerContainer>
          <ApplicationPageLeftColumn>
            <ApplicationPageLeftColumnInner>
              <LogoContainer>
                <Logo
                  src={`/images/ce-montessori/logos/ce-montessori-logo-horizontal-black-city-text.png`}
                  alt={`c'e Montessori - Logo`}
                />
              
                {page.logoTitle && (<LogoTitle>{page.logoTitle}</LogoTitle>)}
  
                {page.logoSubTitle && (<LogoSubTitle>{page.logoSubTitle}</LogoSubTitle>)}
  
                {page.logoDescription && (<LogoDescription>{page.logoDescription}</LogoDescription>)}
              </LogoContainer>
            </ApplicationPageLeftColumnInner>
          </ApplicationPageLeftColumn>
          
          <ApplicationPageRightColumn>
            <ApplicationForm name='Application Form' page={page} />
          </ApplicationPageRightColumn>
        </ApplicationPageInnerContainer>
      </ApplicationPageContainer>
    );
  }
}

ApplicationPage.propTypes = {
  config: PropTypes.shape({
    hasHeader: PropTypes.bool.isRequired,
  }),
  content: PropTypes.shape({
    header: {
      config: PropTypes.shape({
        showLogo: PropTypes.bool,
      }),
      content: PropTypes.shape({
        navigationItems: PropTypes.shape({
          label: PropTypes.string.isRequired,
          link: PropTypes.string.isRequired,
        }).isRequired,
      }),
    },
    page: PropTypes.shape({
      title: PropTypes.string.isRequired,
      subtitle: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      featuredImage: PropTypes.string,
    }).isRequired,
  }),
};

ApplicationPage.defaultProps = {
  config: {
    hasHeader: true,
  },
};

export default ApplicationPage;